import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { EditShieldDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/edit-shield-delete.component";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { UserManagementService } from "src/app/services/user-management.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { EditUserPermissionComponent } from "../edit-permissions/editpermissions.component";
import { Title } from "@angular/platform-browser";


@Component({
    selector: 'app-listusers',
    templateUrl: './listusers.component.html',
    styleUrls: ['./listusers.component.scss']
})

export class ListUsersComponent implements OnInit, OnDestroy {
    usersList = [];
    isActionAllowed = true;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 20,
        domLayout: "autoHeight"
    }

    columnDefs = [
        { headerName: 'Email', field: 'emailid' },
        { headerName: 'User Name', field: 'username' },
        { headerName: 'Role', field: 'rolename' },
        { headerName: 'Mobile No', field: 'mobileno' },
        // { headerName: 'Company', field: 'companyname' },
        {
            headerName: 'Actions',
            field: 'id',
            cellRenderer: EditShieldDeleteActionsRenderer,
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
            filter: false
        },
    ];

    rowData = [];
    selectedSCId = null;

    constructor(
        public router: Router,
        private appCoreService: AppCoreService,
        private ngxLoaderService: NgxUiLoaderService,
        private userManagementService: UserManagementService,
        public modalService: NgbModal,
        private titleService: Title
    ) {
        titleService.setTitle('Users');
        this.context = { componentParent: this };
    }

    ngOnInit(): void {
        this.checkPermission();
        this.appCoreService.SelectedServiceCenter().subscribe((val) => {
            this.selectedSCId = val;
            this.bindUserList();
        });
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        const permission = userData.config.filter(x => x.categoryname === 'Users');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    bindUserList(refresh = false) {
        try {
            this.ngxLoaderService.start();
            this.userManagementService.GetAll({ id: this.selectedSCId, refresh: refresh }).subscribe((res: any) => {
                if (res && res.success) {
                    // console.log(res);
                    this.ngxLoaderService.stop();
                    this.rowData = res.data;
                } else {
                    this.ngxLoaderService.stop();
                }
            })
        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }

    ngOnDestroy(): void { }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
        params.api.sizeColumnsToFit();
    }

    editAction(cell: any) {
        // console.log(cell);
        try {
            if (cell && cell.id) {
                this.router.navigate(['/iam/users/edit', cell.id]);
            }
        } catch (e) {
            console.error(e);
        }
    }

    shieldAction(cell: any) {
        // console.log(cell);
        try {
            if (cell && cell.id) {
                this.open(cell.id)
                // this.router.navigate(['/iam/users/edit', cell.id]);
            }
        } catch (e) {
            console.error(e);
        }
    }

    deleteAction(cell: any) {
        // console.log(cell);
        if (cell && cell.id) {
            this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
        }

    }

    deleteRecord(id) {
        try {
            if (id) {
                this.ngxLoaderService.start();
                this.userManagementService.Delete(id).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.bindUserList(true);
                        this.appCoreService.showMessage('User deleted successfuly', 'Success', 'success');
                    } else if (res && !res.success) {
                        this.ngxLoaderService.stop();
                    }
                });
            }
        } catch (e) {
            this.ngxLoaderService.stop();
            console.error(e);
        }
    }

    open(userId) {
        let ngbModalOptions: NgbModalOptions = {
            ariaLabelledBy: 'modal-basic-title',
            size: 'lg',
            backdrop: 'static',
            keyboard: false
        };
        // this.ngxLoaderService.start();
        const modalRef = this.modalService.open(EditUserPermissionComponent, ngbModalOptions);
        modalRef.componentInstance.userid = userId;
        // console.log('modalRef', modalRef);
        modalRef.result.then(
            (result) => {
                if (result) {
                    //   console.log('Closed with: result', result);
                }
            },
            (reason) => {
                // console.log('Dismissed reason', reason);
            }
        );
        // this.ngxLoaderService.stop();
    }

    async openConfirmationDialog(msg: any, id?: number) {
        const result = await Swal.fire({
            titleText: 'Confirmation',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            this.deleteRecord(id);
        }
    }
}
